<template>
  <div class="row button-style">
    <div class="col-md-12">
      <label class="info-upload-file" v-if="inputShow.type == false"><span v-html="currentField.instruction"></span></label>
    </div>
    <div class="col-sm-12 mt-2">
      <button class="btn btn-primary" type="button" @click="fileModalShow">
        Upload File
      </button><br>
      <textarea class="m-2 form-control" name="" id="" cols="30" rows="5" v-model="currentField.instruction" v-if="inputShow.type == true"></textarea>
      <!-- <input class="m-3" type="textarea" > -->

      <!-- <div class="row m-2" v-if="inputShow.type == true">
                  <app-input
                    class="col-sm-8"
                    type="text-editor"
                    id="text-editor-id"
                    :label="$t('message_placeholder')"
                    v-model="currentField.instruction"
                  />
                </div> -->

    </div>
    <div class="col-sm-12 mt-4">

    <div v-if="currentField.componentId == index" v-for="(file, index) in filePath" :key="index" class="row">
      <div class="col-sm-3 col-4" v-for="(detail , i) in file">
        <!-- <div class="card card-with-shadow border-0" > -->
          <div class="text-center">
            <span>
              <app-icon name="file" />
            </span>
            <h6 class="mt-2 text-center mb-0">
              {{ detail.name }}
            </h6>
            <small>Expiry: {{ detail.expiry }}</small>
          </div>
        <!-- </div> -->
        <div class="text-center my-2">
          <a style="cursor: pointer"
              @click="removeFileAction(detail.component_id, index)"
              class="d-block">
            Remove
          </a>
          <a v-if="isPDF(detail.path)" :href="detail.path" :download="detail.name">Download PDF</a>
          <a href="javascript:void(0)" v-else @click.prevent="openModal(detail.path)">Preview Image</a>
        </div>

      </div>
    </div>

    </div>

      <!-- <div class="col-sm-4" style="padding: 10px !important" v-if="fileData.length > 0" v-for="(doc, i) in fileData" :key="i">
        <div class="card card-with-shadow border-0">
          <div class="card-body text-center">
            <span>
              <app-icon name="file" />
            </span>
            <h6 class="mt-primary text-center mb-0">
              {{ doc.name }}
            </h6>
            <small>Expiry: {{ doc.expiry }}</small>
          </div>
        </div>
        <div class="text-center my-4">
          <a :href="doc.path" download> Download </a>
        </div>
      </div> -->
    <file-upload-modal
      v-if="isFileUploadModal"
      @close-modal="closeFileUploadModal"
      :textvalue="textAreaChange"
      :componentId="currentField.componentId"
    />

    <preview-image-modal
      v-if="isPreviewImageModal"
      @close-modal="closePreviewImageModal"
      :imagePath="imagePath"
      :componentId="currentField.componentId"
    />
    <!-- :textvalue="textAreaChange" SET PROPS file-upload-modal -->

    <!--Delete Modal-->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="task-delete"
      @confirmed="confirmed"
      @cancelled="canceled"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  extends: AppLibrary,
  mixins: [FormMixin],
  name: "UploadMediaFile",
  props: ["currentField"],

  data() {
    return {
      showModal: false,
      imagePath: '',
      fileData:[],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      fileList: [],
      isFileUploadModal: false,
      isPreviewImageModal: false,
      remove_id: 0,
      comp_id:0,
    }
  },
  computed: {
    filePath() {
      let data = this.$store.state.uploadFilePath.dataUploadFilePath;
      return data;
    },
    inputShow() {
      return this.$store.state.inputMode;
    }
  },
  mounted() {
    if (this.currentField.componentValue) {
      const fileData = JSON.parse(this.currentField.componentValue);
      this.documentStoreState(fileData); 
    }
  },
  created() {
   
    this.$store.state.uploadFilePath.dataUploadFilePath = {};
    this.componentId = this.currentField.componentId;
  },
  methods: {
    isImage(path) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif']; // Add more image extensions if needed
      const extension = path.toLowerCase().substring(path.lastIndexOf('.'));
      return imageExtensions.includes(extension);
    },
    isPDF(path) {
      return !this.isImage(path);
    },
    openModal(imagePath) {
      this.imagePath = imagePath;
      this.isPreviewImageModal = true;
    },
    closePreviewImageModal() {
      $("#preview_image_modal").modal("hide");
      this.isPreviewImageModal = false;
    },
    removeFileAction(comp_id, fileid) {
      this.comp_id = comp_id;
      this.remove_id = fileid;
      this.deleteConfirmationModalActive = true;

    },
    confirmed() {
      // 
      this.deleteLoader = true;
      // let cours = this.$store.state.uploadFilePath.dataUploadFilePath[this.comp_id].filter(c => c.id === this.remove_id);
      // 
      // // this.$store.state.uploadFilePath.dataUploadFilePath = cours;
      this.$store.state.uploadFilePath.dataUploadFilePath[this.comp_id].splice(this.remove_id , 1);

      if (this.$store.state.uploadFilePath.dataUploadFilePath[this.comp_id].length == 0) {
        delete this.$store.state.uploadFilePath.dataUploadFilePath[this.comp_id];
      }
      else {
      this.currentField.componentValue = this.$store.state.uploadFilePath.dataUploadFilePath[this.comp_id];
      }



      this.hideDeleteModal();
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
    canceled() {
      this.remove_id = null;
      this.deleteConfirmationModalActive = false;
    },
    
    textAreaChange(data) {
      
      // let file =  data.toString()//JSON.stringify(data,null,"\n");
      this.currentField.componentValue = data;
    },
    fileModalShow() {
      
      this.isFileUploadModal = true;

      // setTimeout(() => {
      //   $(".modal-backdrop").removeClass("show");
      //   $(".modal-backdrop").css("position", "static");
      // }, 1000);
    },
    closeFileUploadModal() {
      $(function () {
        $("#removeclass .modal-dialog ").toggleClass("modal-dialog-scrollable");
      });
      $("#file_modal").modal("hide");
      this.isFileUploadModal = false;
    },

    documentStoreState(files) {
      
        if (files.length > 0) {
        let componentId, id;
        const data = [];
        files.forEach((datas, index) => {

          
          componentId = datas.component_id;
          id = datas.id;
          data.push(
            {
              id : id,
              name : datas.name,
              path : datas.path,
              expiry : datas.expiry,
              component_id : componentId,
            });
            
            this.$store.dispatch("setValueToPassFile", { data, componentId, id }) ;
        });
        
          // this.$store.dispatch("setValueToPassFile", { data, componentId, id }) ;
      }
    },
  },
};
</script>
